//#region redux
import { store } from "store";
//#endregion
//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels, WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import { ApiClientInstance, UtilsHelper } from "utils/helpers";

/**
 * @deprecated This service is deprecated. Use useReceiptService hook instead.
 *
 * @see useReceiptService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const ReceiptService = {
  /**
   * @deprecated This function is deprecated. Move to a custom hook and use useSelector for Redux state access.
   *
   * Migration guide:
   * 1. Create a new custom hook (e.g., useReceiptCategoryFinder)
   * 2. Use useSelector to access Redux state instead of store.getState()
   * 3. Move this logic into the custom hook
   * 4. Use the hook in components instead of calling this function
   *
   * @see useSelector - React Redux hook for accessing state
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * const category = ReceiptService.findReceiptCategoryByCategoryId(categoryId);
   *
   * @example
   * // New way (recommended):
   * function useReceiptCategoryFinder() {
   *   const receiptCategories = useSelector((state: AppState) => state.auth.selectedCompany.receiptCategories);
   *
   *   const findReceiptCategoryByCategoryId = (
   *     receiptCategoryId?: number,
   *     categories?: ApiModels.ReceiptCategory[]
   *   ): ApiModels.ReceiptCategory | undefined => {
   *     if (receiptCategoryId === null) return undefined;
   *     const categoriesToUse = categories || receiptCategories;
   *     return categoriesToUse?.find((x) => x.id === receiptCategoryId);
   *   };
   *
   *   return { findReceiptCategoryByCategoryId };
   * }
   *
   * // In component:
   * const { findReceiptCategoryByCategoryId } = useReceiptCategoryFinder();
   * const category = findReceiptCategoryByCategoryId(categoryId);
   */
  findReceiptCategoryByCategoryId: (
    receiptCategoryId?: number,
    receiptCategories?: ApiModels.ReceiptCategory[]
  ): ApiModels.ReceiptCategory | undefined => {
    if (receiptCategoryId === null) return undefined;
    if (!receiptCategories) {
      receiptCategories = store.getState().auth.selectedCompany.receiptCategories;
    }
    if (receiptCategories) {
      return receiptCategories.find((x) => x.id === receiptCategoryId);
    } else {
      return undefined;
    }
  },
  getReceiptTodoSubType: (
    state?: ApiModels.ReceiptStateApiModel,
    message?: string
  ): WintSuperkollAPIModel.TodoSubType => {
    switch (state) {
      case ApiModels.ReceiptStateApiModel.SentBackToCustomer:
      case ApiModels.ReceiptStateApiModel.SentBackFromReceiptAdmin:
        return WintSuperkollAPIModel.TodoSubType.ReceiptSentBack;
      case ApiModels.ReceiptStateApiModel.WaitingAcceptance:
        if (!UtilsHelper.isEmpty(message)) return WintSuperkollAPIModel.TodoSubType.ReceiptSentBack;
        else return WintSuperkollAPIModel.TodoSubType.ReceiptToApprove;
      default:
        return WintSuperkollAPIModel.TodoSubType.ReceiptToApprove;
    }
  },
  getReceiptsCanBePayedOut: () =>
    ApiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).ReceiptClient.GetCanReceivePayouts(),
};

export default ReceiptService;
